var render = function render(){var _vm=this,_c=_vm._self._c;return _c('horizontal-nav',{attrs:{"show_display":false,"set_view":"","items":_vm.items}})
}
var staticRenderFns = []

export { render, staticRenderFns }